<template>
  <div
    class="wrapper"
    :class="{ layout__fixed: !shrink }"
    :style="
      shrink &&
      `grid-auto-columns: ${prependSaleStatusColumn ? '0 126px' : '50px'} minmax(150px, auto);`
    "
  >
    <div v-if="$slots['prefix']">
      <slot style="background-color: #f5f5f5" name="prefix" />
    </div>
    <div
      v-if="prependSaleStatusColumn"
      class="header_element header_element_sale_status"
      @click="isSaleStatusModalOpen = true"
    >
      <span class="header_element__text">Sale Status</span>
      <img src="/assets/info-rounded.svg" alt="info icon" style="width: 1.25rem; height: 1.25rem" />
    </div>
    <div v-for="(item, i) in items" :key="`${item}/${i}`" class="header_element">
      <span
        class="header_element__text"
        @click="$emit('sort', item)"
        @mouseover="hoveredItem = `${item}`"
        @mouseout="hoveredItem = undefined"
      >
        {{ item }}
      </span>
      <div class="arrow">
        <v-icon
          v-if="pagination && pagination.sortBy === item && item !== ''"
          class="upward_arrow"
          :style="style"
          @click="$emit('sort', item)"
        >
          arrow_upward
        </v-icon>
        <v-icon
          v-if="hoveredItem === item && pagination && pagination.sortBy != item"
          class="hover_arrow"
        >
          arrow_upward
        </v-icon>
      </div>
    </div>
    <sale-status-modal v-if="isSaleStatusModalOpen" @close="isSaleStatusModalOpen = false" />
  </div>
</template>

<script>
import SaleStatusModal from '@/components/tickets/SaleStatusModal.vue'

export default {
  name: 'table-header',
  components: { SaleStatusModal },
  props: {
    shrink: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      deafult: () => {},
    },
    prependSaleStatusColumn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoveredItem: '',
      isSaleStatusModalOpen: false,
    }
  },
  computed: {
    style() {
      return 'transform: rotate(' + (this.pagination.descending ? '180' : '0') + 'deg);'
    },
  },
}
</script>

<style scoped>
.wrapper {
  background-color: #f5f5f5;
  display: grid;
  grid-auto-flow: column;
}

.layout__fixed {
  grid-auto-columns: minmax(170px, auto);
}
.header_element {
  display: flex;
  background-color: #f5f5f5;
  min-width: 100px;
  padding: 10px 12px;
  white-space: nowrap;
  position: relative;
}
.header_element__text {
  font-family: Raleway;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  margin-right: 4px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}
::-webkit-scrollbar {
  height: 0px;
}
.upward_arrow {
  width: 16px;
  height: 16px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  position: absolute;
  z-index: 1;
  color: #0277bd !important;
}
.hover_arrow {
  width: 16px;
  height: 16px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  position: absolute;
  color: '#666666' !important;
}
.arrow {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  /* align-content: center; */
}

.header_element_sale_status {
  max-width: 126px;
  align-items: center;
}
.header_element_sale_status:hover {
  cursor: pointer;
}
</style>
